import {useState} from 'react';
import {useQueryClient} from 'react-query';
import {GoalsController} from '@api/goals-api/goals-controller';
import {GoalsRequestImpl} from '@api/goals-api/goals-request';
import {usePostHogHook} from '@hooks/post-hog';
import {useStoreContext} from '@store/store-context';
import {ConfirmationDialog} from '@ui/molecules/confirmation-dialog';
import {invalidateGoalQueries} from '@utils/goal-query-cache';

export const EndGoal = ({
  endGoal,
  endGoalInAllObjectiveStore,
  endCheckinGoal,
}: {
  endGoal?: (goalId: string, data: any) => void;
  endGoalInAllObjectiveStore?: (goalId: string, data: any) => void;
  endCheckinGoal?: (data: any, goalId: string) => void;
}) => {
  const {goalsState} = useStoreContext();
  const queryClient = useQueryClient();
  const [isEnding, setIsEnding] = useState(false);
  const {postHogCapture} = usePostHogHook();

  const closeModal = () => goalsState.setEndModal('', '', false, '');

  const handleEndGoal = async () => {
    if (isEnding) return;

    setIsEnding(true);
    try {
      const request = new GoalsRequestImpl();
      const controller = new GoalsController(request);
      const ended = await controller.endGoal(
        {completed: true},
        goalsState.endId,
        goalsState.goalFramework,
      );

      if (!ended) return;

      endGoal?.(goalsState.endId, {completed: true});
      endCheckinGoal?.({completed: true}, goalsState.endId);
      endGoalInAllObjectiveStore?.(goalsState.endId, {completed: true});

      await invalidateGoalQueries(queryClient).catch(() => undefined);

      postHogCapture('goal_completed');
      goalsState.setEndModal('', '', false, '');
    } finally {
      setIsEnding(false);
    }
  };

  return (
    <ConfirmationDialog
      open
      title={`End this ${goalsState.goalFramework}?`}
      confirmLabel={`End ${goalsState.goalFramework}`}
      isLoading={isEnding}
      onCancel={closeModal}
      onConfirm={handleEndGoal}>
      Ending <strong>{goalsState.endName}</strong> will stop further progress
      updates.
    </ConfirmationDialog>
  );
};
